export default "__VITE_ASSET__yMKCCrCk__"